export enum PagarmePayableStatus {
  WaitingFunds = "waiting_funds",
  Paid = "paid",
  Prepaid = "prepaid",
}
